import type { CSSProperties } from "react";
import styled, { css } from "styled-components";
import { Link } from "@viagogo/core/ui";
import { Image } from "src/website-apps/shared/components/image";

export const StyledMatchupCard = styled(Link)`
  display: block;
  height: auto;
  width: auto;
`;

export const StyledContentContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const MatchupContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 200px;
  position: relative;
  width: 100%;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    height: 274px;
  }
`;

export const TeamContainer = styled.div<{
  left?: boolean;
  right?: boolean;
  bgColor?: CSSProperties["backgroundColor"];
}>`
  color: white;
  height: 100%;
  position: relative;
  text-align: center;
  width: 50%;

  ${(props) =>
    props.left &&
    css`
      border-radius: 12px 0px 0px 12px;
    `}

  ${(props) =>
    props.right &&
    css`
      border-radius: 0px 12px 12px 0;
    `}

  ${(props) =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor};
    `}
`;

export const StyledNameWrapper = styled.div`
  left: 50%;
  padding: ${(props) => props.theme.spacing(5)};
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`;

export const StyledTeamName = styled.span`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title5)};

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    ${({
      theme: {
        typography: { getStyles, variant },
      },
    }) => getStyles(variant.title4)};
  }

  @media ${({ theme: { media } }) => media.tablet} {
    font-size: 2vw;
  }

  @media ${({ theme: { media } }) => media.desktop} {
    font-size: 1.5vw;
  }
`;

export const EventDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  margin-top: ${(props) => props.theme.spacing(3)};
  width: 100%;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin-top: ${(props) => props.theme.spacing(5)};
  }
`;

export const StyledEventTitle = styled.p`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title5)};
  color: ${(props) => props.theme.colors.textDarker};
  margin-bottom: ${(props) => props.theme.spacing(2.5)};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const StyledEventDetailText = styled.p`
  color: #677383;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-bottom: ${(props) => props.theme.spacing(1)};
`;

export const StyledImage = styled(Image)`
  left: 50%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledVsDiv = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.caption2)};
  align-items: center;
  background-color: ${(props) => props.theme.colors.black};
  border-radius: 50%;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  height: 24px;
  justify-content: center;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  z-index: 1;
`;
